import { useEffect } from 'react';
import { Comment } from '../../../store/Comment';

interface FocusedCommentScrollProps {
  commentId: string;
  thread: Comment[];
  onScrolled: () => void;
}

// Rendered inside the card body so it runs in the commit that renders the comments, and again when one arrives later.
export function FocusedCommentScroll({ commentId, thread, onScrolled }: FocusedCommentScrollProps) {
  useEffect(() => {
    const element = document.getElementById(commentId);
    if (!element) return;
    element.scrollIntoView({ behavior: 'smooth' });
    onScrolled();
  }, [commentId, thread]);
  return null;
}
